import { DEFAULT_STRING } from './defaultValues';

export class OtpVerificationResponse {
	constructor(axiosResponse) {
		this.response = axiosResponse;
		this.accessToken = this.response?.data?.access_token || DEFAULT_STRING;
	}
}

export class AuthTokenResponse {
	constructor(axiosResponse) {
		this.response = axiosResponse;
		this.authToken = this.response?.data?.authenticate_token || DEFAULT_STRING;
	}
}
